import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const QUEUE_KEY = 'pb_offline_progressions';

const getAuthHeaders = () => {
  const token = localStorage.getItem('cardioai_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY)) || [];
  } catch {
    return [];
  }
};

const write = (items) => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent('pb-queue-changed', { detail: items.length }));
};

export const getQueuedCount = () => read().length;

let syncing = false;

export const queueProgression = (entry) => {
  const items = read();
  const queued = { ...entry, queued_id: `q-${Date.now()}`, queued_at: new Date().toISOString() };
  items.push(queued);
  write(items);
  return queued;
};

export const syncProgressions = async () => {
  if (syncing) return 0;

  const items = read();
  if (!items.length || !navigator.onLine) return 0;

  // Claim the queue up front so a second sync cannot send the same entry twice
  syncing = true;
  write([]);

  const remaining = [];
  let synced = 0;

  try {
    for (const item of items) {
      const { queued_id, queued_at, ...payload } = item;
      try {
        await axios.post(`${API}/progression`, payload, { headers: getAuthHeaders() });
        synced += 1;
      } catch (error) {
        const status = error.response?.status;
        // Retry later on connectivity, auth or server errors; drop only rejected data
        if (!status || status === 401 || status === 403 || status >= 500) remaining.push(item);
      }
    }
  } finally {
    write([...remaining, ...read()]);
    syncing = false;
  }

  if (synced > 0) window.dispatchEvent(new CustomEvent('pb-sync-done'));
  return synced;
};

export const clearOfflineData = async () => {
  localStorage.removeItem(QUEUE_KEY);
  window.dispatchEvent(new CustomEvent('pb-queue-changed', { detail: 0 }));
  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.filter((k) => k.endsWith('-api')).map((k) => caches.delete(k)));
  }
};
